import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FeatureList } from '../feature-list';
import * as Styled from './pricing-card.style';

export type PricingCardProps = {
  toggle: React.ReactNode;
  price: React.ReactNode;
  cta: React.ReactNode;
};

export const PricingCard: React.FC<PricingCardProps> = ({
  toggle,
  price,
  cta,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Card>
      <Styled.CardTop>
        <Styled.CardHeader>
          <Typography variant="h5" component="span">
            {t('general.premium')}
          </Typography>
          {toggle}
        </Styled.CardHeader>

        {price}
      </Styled.CardTop>

      <FeatureList />

      <Styled.CardFooter>
        {cta}
        <Styled.Disclaimer>
          {t('dialogs.premium.interactions.disclaimer.title')}
        </Styled.Disclaimer>
      </Styled.CardFooter>
    </Styled.Card>
  );
};
